exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recent-files[data-v-7124ae4a] {\n  max-height: 35vh;\n  min-height: 100px;\n  overflow: scroll;\n  overflow-y: auto;\n}\n", ""]);

// exports
